import axios from "../../lib/axios";
import { IFilter } from "../../types/filters.types";
import checkIsLocalhost from "../../utils/checkIsLocalhost";

const baseUrl = process.env.REACT_APP_API_BASE_URL || "/";

export const getInvoiceReceiptsResearchData = (
  filters: IFilter
): Promise<any> => {
  const isLocalhost = checkIsLocalhost();

  const raw = `{
    getInvoiceReceiptsValues(MViewInput: {DSDVendor: ${filters.dsdVendor}, RetailDivision: ${filters.retailDivision}, RetailStore: ${filters.retailStore}, Department: ${filters.department}, RetailSection: ${filters.retailSection}, SMIC: ${filters.smic}, UPC: ${filters.upc}, CIC: "${filters.cic}"}, DSD_NON_FRESH: "NON_FRESH")
    {
      lastInvoiceRecDate
      invoiceNbr
      vendorIdName
      invoiceTypeCd
      uom
      finalInvoiceQty
      finalPackQty
      receivedUnitsEach
      nextReceiptEstimatedDate
      errors{ errorCode errorDescription }
    }
  }`;
  const url = `${baseUrl}sdiminventory/mview`;

  return axios.post(
    isLocalhost ? "/api/middleware" : url,
    isLocalhost ? { raw, url } : raw
  );
};
